/**
 * Role-based menu and route configuration.
 * Used for restricted roles (e.g. easyAccessOperator) to limit sidebar and route access.
 */

/** userType value for Access System–only operator */
export const USER_TYPE_EASY_ACCESS_OPERATOR = 6;

/** Route that represents Správa lístkov (tickets management) – default landing for easyAccessOperator */
export const ACCESS_SYSTEM_TICKETS_PATH =
  "/customer/dsok/access-system/tickets-management";

/** Route: Správa voucherov / poukážok */
export const ACCESS_SYSTEM_VOUCHERS_PATH =
  "/customer/dsok/access-system/vouchers-management";

/** Route: Zones management */
export const ACCESS_SYSTEM_ZONES_PATH =
  "/customer/dsok/access-system/zones-management";

/** Paths allowed for easyAccessOperator. Only these (or redirects to them) are accessible. */
export const EASY_ACCESS_OPERATOR_ALLOWED_PATHS = [
  ACCESS_SYSTEM_TICKETS_PATH,
  ACCESS_SYSTEM_VOUCHERS_PATH,
  ACCESS_SYSTEM_ZONES_PATH,
  "/customer/dsok/access-system", // redirects to tickets-management
];

/**
 * Role menu config: which top-level menu keys are visible per role.
 * Extensible for future roles.
 */
export const ROLE_MENU_CONFIG = {
  easyAccessOperator: ["access-system"],
};

/**
 * @param {number} userType
 * @returns {boolean}
 */
export function isEasyAccessOperator(userType) {
  return Number(userType) === USER_TYPE_EASY_ACCESS_OPERATOR;
}

/**
 * @param {string} pathname
 * @returns {boolean}
 */
export function isPathAllowedForEasyAccessOperator(pathname) {
  if (!pathname || typeof pathname !== "string") return false;
  const path = pathname.replace(/\?.*$/, "").replace(/\/+$/, "") || "/";
  const vouchersPrefix = `${ACCESS_SYSTEM_VOUCHERS_PATH}/`;
  const zonesPrefix = `${ACCESS_SYSTEM_ZONES_PATH}/`;
  return (
    path === ACCESS_SYSTEM_TICKETS_PATH ||
    path === ACCESS_SYSTEM_VOUCHERS_PATH ||
    path === ACCESS_SYSTEM_ZONES_PATH ||
    path.startsWith(vouchersPrefix) ||
    path.startsWith(zonesPrefix) ||
    path === "/customer/dsok/access-system" ||
    path === "/dsok/processed-order" ||
    path.startsWith("/dsok/processed-order/")
  );
}
